import { useNavigate } from "react-router-dom";
import React from "react";
import { Routines } from "../components";

const Cnt_Routines = () => {
  const navigate = useNavigate();

  const onMinimize = () => {
    navigate("");
  };

  return <Routines.Home onMinimize={onMinimize} />;
};

export default Cnt_Routines;
